export default __webpack_public_path__ + "static/media/booksearch.5e707023.png";